// extracted by mini-css-extract-plugin
export default {"form":"ResetADMPassword_form__kMd1s","input":"ResetADMPassword_input__3OKVV","password-error":"ResetADMPassword_password-error__GICgw","button":"ResetADMPassword_button__2xx6x"};